export default "__VITE_ASSET__BXRMWiKZ__"